var play_icon_default = {
  "shadow": "-xBN1",
  "playIcon": "XvtQC"
};
export {
  play_icon_default as default
};
//# sourceMappingURL=play-icon-scss.js.map
